import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useParams } from 'react-router-dom';
import ArrowLeft from '../../Assets/Arrow left.svg';
import { fetchCollectionData } from '../../Features/collectionsSlice';
import SearchIcon from '../../Assets/OrderManagement/SearchIcon.svg';
import ProductBox from './ProductBox';
import Error from '../../Components/Error/Error';
import Loading from '../../Components/Loading/Loading';

function CollectionProducts() {
    const dispatch = useDispatch();
    const location = useLocation();
    const params = useParams();

    const { collectionData, loading } = useSelector((state) => state.collections.collectionData);

    const [searchValue, setSearchValue] = useState('');
    const [searchList, setSearchList] = useState([]);

    const handleChange = (e) => {
        setSearchValue(e.target.value);
    }

    useEffect(() => {
        if(searchValue) {
            const filteredList = collectionData.product.filter(product => product.productName.toLowerCase().includes(searchValue.toLowerCase()));
            setSearchList(filteredList);
        }
        else {
            if(Object.keys(collectionData).length > 0) {
                setSearchList(collectionData.product);
            }
        }
    }, [collectionData, searchValue]);

    useEffect(() => {
        if(params.collectionId) {
            dispatch(fetchCollectionData(params.collectionId));
        }
        // eslint-disable-next-line
    }, [params.collectionId]);

    useEffect(() => {
        if(Object.keys(collectionData).length > 0) {
            setSearchList(collectionData.product);
        }
    }, [collectionData]);

    if(loading === 'loading') {
        return <Loading />
    }

    if(loading === 'failed') {
        return <Error />
    }

    return (
        <div className="size-full overflow-y-scroll pb-16 outline-none">
            <div className="select-none flex items-center justify-between gap-2 relative m-[20px_19px_24px_20px]">
                <div className="flex items-center">
                    <Link to={`${location.pathname.split('/').slice(0, -2).join('/')}`} className="p-[10px] flex items-center justify-center">
                        <img className='size-6 text-[#666666]' src={ArrowLeft} alt="" />
                    </Link>

                    <h1 className="p-[6px] text-[#121212] font-bold text-2xl flex items-baseline gap-1">{collectionData?.collection?.CollectionName}<span className='font-medium text-[16px] leading-8'>&#40;{searchList?.length} product{searchList?.length > 1 ? 's' : ''}&#41;</span></h1>
                </div>

                <div className="flex items-center gap-2">
                    <div className="border border-[#EAEAEA] px-4 py-[10px] rounded-lg bg-[#F5F5F5] flex items-center gap-1 w-80 focus-within:border-primaryColor">
                        <div className="size-5">
                            <img src={SearchIcon} alt="" />
                        </div>

                        <input 
                            className='w-[calc(100%-20px)] outline-none bg-transparent font-medium text-[14px] leading-[22px] text-[#121212] placeholder:text-[#666666]' 
                            placeholder='Search by product name' 
                            type="text" 
                            id='search' 
                            name='search' 
                            value={searchValue} 
                            onChange={handleChange} 
                        />
                    </div>
                </div>
            </div>

            <div className="mt-4 mx-5 grid grid-cols-5 gap-x-3 gap-y-3 max-[1280px]:grid-cols-4 max-[1152px]:grid-cols-3">
                {searchList?.map(product => {
                    let imageUrl = product.productImgUrls[0] || '';

                    return (
                        <ProductBox 
                            key={product.id} 
                            product={product} 
                            imageUrl={imageUrl} 
                        />
                    )
                })}
            </div>
        </div>
    );
}

export default CollectionProducts;
